<template>
  <main class="-mt-32" v-if="loaded">
    <div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8 py-10 -mt-32">
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
          <div
            class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
          >
            <div class="ml-4 mt-2">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                {{ client.name }}
              </h3>
            </div>
            <div class="mt-4 flex md:mt-0 md:ml-4">
              <template v-if="client.id" class="flex-shrink-0 ml-4">
                <span class="shadow-sm rounded-md mr-3">
                  <button
                    @click="destroy"
                    type="button"
                    class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:shadow-outline-red focus:border-red-700 active:bg-red-700 transition duration-150 ease-in-out"
                  >
                    Elimina
                  </button>
                </span>
              </template>
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  @click="save"
                  type="button"
                  class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                >
                  Salva
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="main-container px-4 py-4 sm:px-6">
          <div class="h-full">
            <div class="h-full md:grid md:grid-cols-3 md:gap-3">
              <div class="hidden md:block md:col-span-1">
                <h3 class="text-lg font-medium leading-6 text-gray-900">
                  Informazioni di contatto
                </h3>
              </div>
              <div class="scrollable mt-5 md:mt-0 md:col-span-2">
                <div class="grid grid-cols-6 gap-3">
                  <div class="col-span-6 sm:col-span-4">
                    <label
                      for="name"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Ragione Sociale</label
                    >
                    <input
                      id="name"
                      v-model="client.name"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-4">
                    <label
                      for="email_address"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Indirizzo Email</label
                    >
                    <input
                      id="email_address"
                      v-model="client.email"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label
                      for="phone"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Telefono</label
                    >
                    <input
                      id="phone"
                      v-model="client.phone"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label
                      for="mobile"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Mobile</label
                    >
                    <input
                      id="mobile"
                      v-model="client.mobile"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6">
                    <label
                      for="street_address"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Indirizzo</label
                    >
                    <input
                      id="street_address"
                      v-model="client.address"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-6 lg:col-span-2">
                    <label
                      for="city"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Città</label
                    >
                    <input
                      id="city"
                      v-model="client.city"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label
                      for="state"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Provincia</label
                    >
                    <input
                      id="state"
                      v-model="client.province"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label
                      for="postal_code"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >CAP</label
                    >
                    <input
                      id="postal_code"
                      v-model="client.zip"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label
                      for="vat"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Partita IVA</label
                    >
                    <input
                      id="vat"
                      v-model="client.vat"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label
                      for="cf"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Codice Fiscale</label
                    >
                    <input
                      id="cf"
                      v-model="client.fiscal_code"
                      class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    id: {
      required: false,
    },
  },

  data: () => {
    return {
      loaded: false,
    };
  },

  computed: {
    ...mapState("client", ["client"]),
    ...mapState("app", ["user"]),
  },

  methods: {
    save() {
      this.$store.dispatch("client/SAVE", this.client);
    },
    destroy() {
      if (confirm("Sicuro di voler cancellare il cliente?")) {
        this.$store.dispatch("client/DELETE");
        this.$router.go(-1);
      }
    },
  },

  async mounted() {
    this.$store.dispatch("client/RESET");
    if (this.id) {
      await this.$store.dispatch("client/CLIENT", { id: this.id });
    }
    this.loaded = true;
  },
};
</script>
